/**
 * Created by zad on 17/10/25.
 */
import { Global } from '../constants/actionTypes';
import createAction from '../utils/createAction';

export const setBindPhoneStatus = createAction(Global.SET_BIND_PHONE_STATUS, 'hasBind');

export const setPublishSuccessData = createAction(Global.SET_PUBLISH_SUCCESS_MODAL_DATA, 'show', 'data');

export const setQrCodeModalData = createAction(Global.SET_QRCODE_MODAL_DATA, 'show', 'data');

export const setNoteData = createAction(Global.SET_NOTE_DATA, 'data');

export const switchDev = createAction(Global.SWITCH_DEV);

export const changeLocale = createAction(Global.CHANGE_LOCALE, 'locale');

export const changeReadMode = createAction(Global.CHANGE_READ_MODE, 'readMode');

export const changeFontType = createAction(Global.CHANGE_FONT_TYPE, 'fontType');

export const setPnAgreeModalData = createAction(Global.SET_PNAGREE_MODAL_DATA, 'show', 'data');

export const setSortedNoteData = createAction(Global.SET_SORTED_NOTE_DATA, 'data');
export const setBindStatus = createAction(Global.SET_BIND_STATUS, 'status', 'data');
export const setBindWxStatus = createAction(Global.SET_BIND_WX_STATUS, 'status');
export const setOccupyHasOther = createAction(Global.SET_OCCUPY_HASOTHER, 'status', 'msg');
export const setOccupyNoother = createAction(Global.SET_OCCUPY_NOOTHER, 'status', 'msg', 'step', 'data');

export const openTimePublishBuyModalAction = createAction(Global.OPEN_TIME_PUBLISH_BUY_MODAL, 'data');
export const closeTimePublishBuyModalAction = createAction(Global.CLOSE_TIME_PUBLISH_BUY_MODAL);



// WEBPACK FOOTER //
// ./src/actions/GlobalAction.js